﻿import { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import type { AuthUser, UserPermissions } from "../../app/auth";
const menuLogo = "/objektvote-menu-logo.png";

type MenuItem = {
  to: string;
  label: string;
  icon: "dashboard" | "objects" | "units" | "owners" | "assignments" | "resolutions" | "imports" | "audit" | "debug" | "templates" | "settings" | "users" | "platform" | "scan";
};

const items: MenuItem[] = [
  { to: "/", label: "Dashboard", icon: "dashboard" },
  { to: "/resolutions", label: "Umlaufbeschlüsse", icon: "resolutions" },
  { to: "/analog-scan", label: "QR Erfassung", icon: "scan" },
  { to: "/objects", label: "Objekte", icon: "objects" },
  { to: "/units", label: "Einheiten", icon: "units" },
  { to: "/owners", label: "Eigentümer", icon: "owners" },
  { to: "/assignments", label: "Zuordnungen", icon: "assignments" },
  { to: "/imports", label: "Datenabgleich | Import", icon: "imports" },
  { to: "/templates", label: "Vorlagen", icon: "templates" },
  { to: "/settings", label: "Einstellungen", icon: "settings" },
  { to: "/admin-users", label: "Benutzer & Rechte", icon: "users" },
  { to: "/platform-tenants", label: "SaaS-Mandanten", icon: "platform" },
  { to: "/audit", label: "Protokolle", icon: "audit" },
  { to: "/debug", label: "Debug", icon: "debug" }
];

const NavIcon = ({ icon }: { icon: MenuItem["icon"] }) => {
  if (icon === "dashboard") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4.5 10.2 12 4.5l7.5 5.7v8.8H14v-5.1h-4v5.1H4.5v-8.8Z" stroke="currentColor" strokeWidth="1.9" strokeLinejoin="round" />
      </svg>
    );
  }
  if (icon === "objects") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4.9 8.2h14.2v10.9H4.9z" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  if (icon === "units") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="5.1" y="4.8" width="13.8" height="14.8" rx="2.1" stroke="currentColor" strokeWidth="1.85" />
        <path d="M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" />
        <path d="M9.2 19.6v-2.9h5.6v2.9" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (icon === "owners") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="9.1" cy="9.1" r="2.5" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="15.8" cy="8.4" r="2.1" stroke="currentColor" strokeWidth="1.8" />
        <path d="M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  if (icon === "assignments") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="6.2" cy="7.2" r="2.1" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17.8" cy="16.8" r="2.1" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17.8" cy="7.2" r="2.1" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8.4 7.2h7.2M7.9 8.8l7.4 6.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  if (icon === "resolutions") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M7.1 4.6h6.6l3.2 3.2v11.6H7.1z" stroke="currentColor" strokeWidth="1.85" strokeLinejoin="round" />
        <path d="M13.7 4.8v3.1h3" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" />
        <path d="m9.4 14.1 2 2 4.2-5" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="17.7" cy="17.8" r="2.1" fill="#fff" stroke="currentColor" strokeWidth="1.85" />
      </svg>
    );
  }
  if (icon === "imports") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 5.3v8.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="m8.8 11 3.2 3.2 3.2-3.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="4.8" y="15.8" width="14.4" height="3.8" rx="1.4" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    );
  }
  if (icon === "scan") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="5.4" y="5.4" width="4.4" height="4.4" rx="0.7" stroke="currentColor" strokeWidth="1.8" />
        <rect x="14.2" y="5.4" width="4.4" height="4.4" rx="0.7" stroke="currentColor" strokeWidth="1.8" />
        <rect x="5.4" y="14.2" width="4.4" height="4.4" rx="0.7" stroke="currentColor" strokeWidth="1.8" />
        <path d="M14.2 14.2h2.2v2.2h-2.2zM17.4 14.2h1.2M14.2 17.4h1.2M17 17h1.6v1.6H17z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round" />
      </svg>
    );
  }
  if (icon === "audit") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5.2 19.2h13.6M7.2 19.2V11M12 19.2V7.8M16.8 19.2v-5.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  if (icon === "debug") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M13 2 5 13h6l-1 9 9-13h-6l1-7Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (icon === "templates") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4.8 8a1.8 1.8 0 0 1 1.8-1.8h4.2l1.5 1.7h5.1A1.8 1.8 0 0 1 19.2 9v8.2a1.8 1.8 0 0 1-1.8 1.8H6.6a1.8 1.8 0 0 1-1.8-1.8V8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    );
  }
  if (icon === "settings") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 7h14M5 12h14M5 17h14" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
        <circle cx="9" cy="7" r="2" fill="#fff" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="15" cy="12" r="2" fill="#fff" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="11" cy="17" r="2" fill="#fff" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    );
  }

  if (icon === "platform") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="4" y="5.2" width="16" height="11.6" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M9.2 19h5.6M12 16.8V19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="5.2" y="4.8" width="13.6" height="14.4" rx="1.9" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8.2 9.4h7.6M8.2 13h7.6M8.2 16.6h4.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
};

type SidebarProps = {
  mode?: "desktop" | "mobile";
  onNavigate?: () => void;
  onClose?: () => void;
  onLogout?: () => void;
  navBg?: string;
  frameworkMode?: "classic" | "mockup_v2";
  authUser?: AuthUser | null;
  showPlatformMenu?: boolean;
  platformOnlyMode?: boolean;
  permissions?: UserPermissions;
};

const groups = [
  {
    title: "Übersicht",
        routes: ["/", "/resolutions", "/analog-scan"]
  },
  {
    title: "Verwaltung",
    routes: ["/objects", "/units", "/owners", "/assignments"]
  },
  {
    title: "Setup",
    routes: ["/imports", "/templates"]
  },
  {
    title: "System",
    routes: ["/settings", "/admin-users", "/platform-tenants", "/audit", "/debug"]
  }
];

export const Sidebar = ({
  mode = "desktop",
  onNavigate,
  onClose,
  onLogout,
  frameworkMode = "classic",
  authUser,
  showPlatformMenu = false,
  platformOnlyMode = false,
  permissions
}: SidebarProps) => {
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const [avatarLoadFailed, setAvatarLoadFailed] = useState(false);
  const [accountHoverActive, setAccountHoverActive] = useState(false);
  const year = new Date().getFullYear();
  const isMobile = mode === "mobile";
  const isFrameworkV2 = frameworkMode === "mockup_v2";
  const roleLabel = authUser?.permissionGroupName?.trim()
    ? authUser.permissionGroupName.trim()
    : authUser?.role === "superadmin"
      ? "Superadmin"
      : authUser?.role === "platform_admin"
        ? "Platform Admin"
        : authUser?.role === "platform_superadmin"
          ? "Platform Superadmin"
          : authUser?.role === "platform_ops"
            ? "Platform Ops"
            : authUser?.role === "sachbearbeitung"
              ? "Verwalter"
              : "Lesend";
  const initials = useMemo(() => {
    const source = String(authUser?.displayName ?? authUser?.username ?? "").trim();
    if (!source) return "--";
    const parts = source.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    return source.slice(0, 2).toUpperCase();
  }, [authUser?.displayName, authUser?.username]);
  useEffect(() => {
    setAvatarLoadFailed(false);
  }, [authUser?.avatarUrl]);
  useEffect(() => {
    if (!accountMenuOpen || accountHoverActive) return;
    const timeoutId = window.setTimeout(() => setAccountMenuOpen(false), 5000);
    return () => window.clearTimeout(timeoutId);
  }, [accountMenuOpen, accountHoverActive]);
  const visibleGroups = platformOnlyMode ? [{ title: "Plattform", routes: ["/platform-tenants", "/admin-users", "/settings"] }] : groups;
  const routePermissionMap: Record<string, keyof UserPermissions> = {
    "/": "dashboard",
    "/resolutions": "resolutions",
    "/analog-scan": "qr_scan",
    "/objects": "objects",
    "/units": "units",
    "/owners": "owners",
    "/assignments": "assignments",
    "/imports": "imports",
    "/templates": "templates",
    "/settings": "settings",
    "/admin-users": "admin_users",
    "/platform-tenants": "platform_tenants",
    "/audit": "audit",
    "/debug": "debug"
  };
  const hasRoutePermission = (route: string) => {
    const key = routePermissionMap[route];
    if (!key) return true;
    if (!permissions) return true;
    return permissions[key] !== false;
  };
  const platformMenuOrder: Record<string, number> = {
    "/platform-tenants": 1,
    "/admin-users": 2,
    "/settings": 3
  };
  const getGroupItems = (groupRoutes: string[]) =>
    items
      .filter((item) => groupRoutes.includes(item.to))
      .filter((item) => (item.to === "/platform-tenants" ? showPlatformMenu : true))
      .filter((item) => hasRoutePermission(item.to))
      .filter((item) =>
        platformOnlyMode ? ["/platform-tenants", "/admin-users", "/settings"].includes(item.to) : true
      )
      .filter((item) => (platformOnlyMode ? showPlatformMenu : true))
      .sort((a, b) => {
        if (!platformOnlyMode) return 0;
        return (platformMenuOrder[a.to] ?? 999) - (platformMenuOrder[b.to] ?? 999);
      });

  return (
    <aside className={`sidebar ${isMobile ? "mobile-sidebar" : "desktop-sidebar"}`}>
      <div className="sidebar-main">
        <div className="sidebar-head">
          {isMobile ? (
            <button type="button" className="sidebar-close-btn" onClick={onClose} aria-label="Menü schließen">
              ×
            </button>
          ) : null}
        </div>

        <div className="sidebar-brand-slot" aria-label="App Logo">
          <span className="sidebar-brand-logo">
            <img src={menuLogo} alt="ObjektVote Logo" className="sidebar-brand-logo-image" />
          </span>
        </div>

        {visibleGroups.map((group) => (
          <div key={group.title} className="sidebar-group">
            <div className="sidebar-group-title">{group.title}</div>
            {getGroupItems(group.routes).map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `nav-link ${item.to === "/resolutions" ? "nav-link--resolutions-accent" : ""} ${platformOnlyMode && item.to === "/admin-users" ? "nav-link--platform-gap" : ""} ${isActive ? "active" : ""}`
                  }
                  onClick={() => {
                    setAccountMenuOpen(false);
                    onNavigate?.();
                  }}
                >
                  <span className="nav-link-icon" aria-hidden="true">
                    <NavIcon icon={item.icon} />
                  </span>
                  <span className="nav-link-label">{item.label}</span>
                </NavLink>
              ))}
          </div>
        ))}
      </div>

      {isFrameworkV2 && authUser ? (
        <div className="sidebar-account">
          <div
            className={`sidebar-account-card ${accountMenuOpen ? "open" : ""}`}
            onMouseEnter={() => setAccountHoverActive(true)}
            onMouseLeave={() => setAccountHoverActive(false)}
          >
            <button
              type="button"
              className={`sidebar-account-trigger ${accountMenuOpen ? "open" : ""}`}
              onClick={() => setAccountMenuOpen((value) => !value)}
            >
              <span className="sidebar-account-avatar">
                {authUser.avatarUrl && !avatarLoadFailed ? (
                  <img
                    src={authUser.avatarUrl}
                    alt={authUser.displayName}
                    className="sidebar-account-avatar-image"
                    onError={() => setAvatarLoadFailed(true)}
                  />
                ) : (
                  initials
                )}
              </span>
              <span className="sidebar-account-copy">
                <strong className="sidebar-account-name">{authUser.displayName}</strong>
                <span className="sidebar-account-role">{roleLabel}</span>
              </span>
              <span className="sidebar-account-chevron" aria-hidden="true">
                <svg viewBox="0 0 20 20" fill="none">
                  <path d="M6 8l4 4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </button>
            {accountMenuOpen && onLogout ? (
              <button
                type="button"
                className="sidebar-account-logout"
                onClick={() => {
                  setAccountMenuOpen(false);
                  onLogout();
                }}
              >
                <span className="sidebar-account-logout-icon" aria-hidden="true">
                  <svg viewBox="0 0 20 20" fill="none">
                    <path d="M8 4.5H5.8A1.8 1.8 0 0 0 4 6.3v7.4a1.8 1.8 0 0 0 1.8 1.8H8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                    <path d="M11 13.5 14.5 10 11 6.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8.2 10h6.1" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                  </svg>
                </span>
                <span>Abmelden</span>
              </button>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="sidebar-footer">
          <a href="https://immobilien-mainz.de" target="_blank" rel="noreferrer">
            {`Copyright ${year} Emig Immobilien`}
          </a>
        </div>
      )}
    </aside>
  );
};

